var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-banner',_vm._g(_vm._b({attrs:{"color":_vm.color,"icon":_vm.icon,"single-line":_vm.singleLine,"sticky":_vm.sticky,"value":_vm.value},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_vm._t("actions")]},proxy:true}],null,true)},'v-banner',_vm.$attrs,false),_vm.$listeners),[_c('v-banner-text',[_vm._t("text")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }